module.exports = __webpack_public_path__ + "video/2200-1_YR_2022_Ransomware.71e971e2.vtt";